'use client';

import { Speaker as TSpeaker } from '@/types';
import Image from '@components/Image';
import RawHtml from '@components/RawHtml';
import clsx from 'clsx';
import { useId, useState } from 'react';

import MinusIcon from '@/icons/minus.svg';
import PlusIcon from '@/icons/plus.svg';

type Props = { speaker: TSpeaker };

function Speaker(props: Props) {
  const { speaker } = props;
  const [expanded, setExpanded] = useState(false);

  const id = useId();

  return (
    <div className='speaker'>
      {speaker.picture ? (
        <Image className='speaker__picture' image={speaker.picture} />
      ) : (
        <div className='speaker__picture'></div>
      )}
      <p className='speaker__name'>{speaker.name}</p>
      <RawHtml
        aria-live='polite'
        className={clsx('speaker__bio', { 'speaker__bio--expanded': expanded })}
        html={speaker.biography}
        id={id}
      />
      <button
        type='button'
        aria-expanded={expanded}
        aria-controls={id}
        className='speaker__read-more-button'
        onClick={() => setExpanded(prev => !prev)}
      >
        {expanded ? <MinusIcon width={24} height={24} /> : <PlusIcon width={24} height={24} />}
      </button>
    </div>
  );
}

export default Speaker;
